import { render } from "./BaseSideBar.vue?vue&type=template&id=993476d4&scoped=true"
import script from "./BaseSideBar.vue?vue&type=script&lang=js"
export * from "./BaseSideBar.vue?vue&type=script&lang=js"

import "./BaseSideBar.vue?vue&type=style&index=0&id=993476d4&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993476d4"]])

export default __exports__